let article = '';

export default function currentArticle(state = article, action) {
  switch (action.type) {
    case 'UPDATE_ARTICLE':
      state = '/' + (action.payload.startsWith('/') ? action.payload.slice(1,) : action.payload);
      return state;
    default:
      return state
  }
}